import React, { memo } from 'react'
import { Box } from '@mui/material'

import Text from '../text/Text'
import CustomLinearProgress from './CustomLinearProgress'

const MilestoneProgress = ({ description, completed, rootSx }) => {
  return (
    <Box sx={{ width: '100%', mb: 1, mt: 1, ...rootSx }}>
      <Box
        display='flex'
        alignItems='center'
        sx={{
          pb: '5px'
        }}
      >
        <Text
          variant='h6'
          label={`${completed}%`}
          fontWeight={500}
          sx={{ fontSize: '1.25rem' }}
        />
        <Box
          sx={{
            ml: 'auto',
            textAlign: 'right'
          }}
        >
          <Text
            variant='h6'
            label={description}
            fontWeight={500}
            sx={{ fontSize: '1.25rem' }}
          />
        </Box>
      </Box>
      <CustomLinearProgress value={completed} size={20} />
    </Box>
  )
}

export default memo(MilestoneProgress)
